import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-6 md:py-8 bg-stone-50 border-t border-stone-100" data-id="element-175">
      <div className="max-w-2xl mx-auto px-6 text-center" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-177">
          <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg shadow-green-200" data-id="element-178">
            <ShieldCheck className="w-8 h-8 text-white" data-id="element-179" />
          </div>

          <p className="text-sm md:text-base text-stone-600 font-medium leading-relaxed" data-id="element-180">
            Compre, acesse e aplique. Se por qualquer motivo você não ficar
            satisfeita,{' '}
            <span className="text-stone-900 font-bold" data-id="element-181">
              devolvemos 100% do valor em até 7 dias
            </span>{' '}
            — sem burocracia, sem questionamento.
          </p>
        </motion.div>
      </div>
    </section>;
}